import axios from 'axios';
import { NEW_PASSWORD_URL } from '../constants';

export function newPassword(data: { password: string; password2: string; code: string }) {
  return axios.post(NEW_PASSWORD_URL, data);
}
